var path = 'areas/library/steps/views/index.html';
var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/library/steptemplates\">Step Templates</a></li> </script> <div ng-if=\"userStepTemplates || communityStepTemplates\"> <loading-wrapper busy=isLoading> <installed-step-templates user-installed-templates=userStepTemplates add-custom-step-template-url=addCustomStepTemplateUrl community-step-templates-enabled=IsCommunityActionTemplatesEnabled community-installed-templates=communityStepTemplates install-community-step-template-url=installCommunityStepTempalteUrl resolve-link=resolveLink import=addImport></installed-step-templates> </loading-wrapper> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/library/steps/views/index.html
// module id = 817
// module chunks = 1